export const WASTE_SUBMISSIONS_OMNISEARCH_SESSION_KEY =
  "wasteSubmissionsOmnisearch";

export function getWasteSubmissionsUrl(
  tenantId: string,
  omnisearch?: string | null
): string {
  if (!omnisearch) {
    return `/o/${tenantId}/waste/submissions`;
  }

  return `/o/${tenantId}/waste/submissions?omnisearch=${encodeURIComponent(
    omnisearch
  )}`;
}

export function getSavedWasteSubmissionsUrl(tenantId: string): string {
  const savedOmnisearch = sessionStorage.getItem(
    WASTE_SUBMISSIONS_OMNISEARCH_SESSION_KEY
  );
  return getWasteSubmissionsUrl(tenantId, savedOmnisearch);
}
